var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivationProgressiveScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.968,
    height: 20,
    viewBox: "0 0 19.968 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#04bf2a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1224.647 -5349.809)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1210.737,5359.809l2.625-2.625a.8.8,0,0,0,0-1.028.8.8,0,0,0-1.127-.1l-2.624,2.625-2.625-2.625a.8.8,0,0,0-1.034,0,.8.8,0,0,0-.094,1.128l2.625,2.624-2.625,2.625a.8.8,0,0,0,0,1.04.8.8,0,0,0,1.128.088l2.624-2.625,2.625,2.625a.8.8,0,0,0,1.127,0,.938.938,0,0,0,0-1.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1220.805,5362.486a.684.684,0,0,0,0,.967.684.684,0,0,0,.966,0l3.084-3.087a.679.679,0,0,0,.2-.5.671.671,0,0,0-.2-.5l-3.084-3.086a.683.683,0,0,0-.965.027.683.683,0,0,0,0,.938l1.939,1.935h-5.764c-.018.365-.02.831.006,1.364h5.758Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1224.541,5358.22s-.037.22-.067.6c.02-.2.036-.405.067-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1214.679,5349.809a9.991,9.991,0,0,0-9.862,8.411c-.031.2-.047.4-.067.6-.011.119-.032.236-.039.357h5.781l-1.939-1.935a.683.683,0,0,1,0-.938.683.683,0,0,1,.965-.027l3.084,3.086a.671.671,0,0,1,.2.5.679.679,0,0,1-.2.5l-3.084,3.087a.684.684,0,0,1-.966,0,.684.684,0,0,1,0-.967l1.939-1.942h-5.776c.006.085.022.166.031.25a9.844,9.844,0,0,0,.21,1.272,9.985,9.985,0,0,0,9.722,7.743,10,10,0,0,0,10-10A10,10,0,0,0-1214.679,5349.809Zm6.567,13.752a.8.8,0,0,1-1.127,0l-2.625-2.625-2.624,2.625a.8.8,0,0,1-1.128-.088.8.8,0,0,1,0-1.04l2.625-2.625-2.625-2.624a.8.8,0,0,1,.094-1.128.8.8,0,0,1,1.034,0l2.625,2.625,2.624-2.625a.8.8,0,0,1,1.127.1.8.8,0,0,1,0,1.028l-2.625,2.625,2.625,2.625A.938.938,0,0,1-1208.112,5363.561Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivationProgressiveScheduled);
export default __webpack_public_path__ + "static/media/deactivation-progressive-scheduled.ec13d902672ccc462fd6ad6a0b589427.svg";
export { ForwardRef as ReactComponent };